export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  destktop: 1260
}

export type ScreenType = "mobile" | "tablet" | "desktop" | "bigscreen" | "loading"
